import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import Loader from "../../../components/ui/Loader/Loader";

const DeviceSearchModal = forwardRef(({ submitSearchFormProp }, ref) => {

    const modalElem = useRef(null);
    const searchModal = useRef(null);
    const initialSearching = {
        device_type: '',
        iemi_number: ""
    }
    const [SearchForm, setSearchForm] = useState(initialSearching);
    const [formLoading, setFormLoading] = useState(false);

    const searchFormLabel = {
        device_type: 'Device Type : ',
        iemi_number: "Imei Number : "

    };
    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
        },
        clearSearchForm: () => {
            setSearchForm(initialSearching)
        }
    }));

    useEffect(() => {
        modalElem.current = document.getElementById("deviceSearchID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);
    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(SearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = SearchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;

                    if (key == 'device_type') {
                        show_val = SearchForm ? SearchForm.device_type : '';
                    }

                    if (key == 'iemi_number') {
                        show_val = SearchForm ? SearchForm.iemi_number : '';
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitSearchFormProp(searchedElems, SearchForm);
        searchModal.current.hide();
    };

    return (
        <>
            <div className="modal fade" id={"deviceSearchID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deviceSearchModalLabel">Device Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="deviceSearchForm" onSubmit={submitSearchForm}>
                                <div className="modal-body">
                                    {formLoading ? <Loader />
                                        : <>

                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Device Type</label>
                                                <div className="col-sm-10">
                                                    <input
                                                        name="device_type"
                                                        type="text"
                                                        value={SearchForm.device_type}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            setSearchForm(pre => ({ ...pre, [e.target.name]: e.target.value }))
                                                        }}
                                                        placeholder="Please Enter Device Type"
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Imei Number</label>
                                                <div className="col-sm-10">
                                                    <input
                                                        name="iemi_number"
                                                        type="text"
                                                        value={SearchForm.iemi_number}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            setSearchForm(pre => ({ ...pre, [e.target.name]: e.target.value }))
                                                        }}
                                                        placeholder="Please Enter Imei Number"
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </div>
                                            </div>

                                        </>}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={formLoading} className="btn btn-primary">Search</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default DeviceSearchModal;
